import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Card,
  CardContent,
  Grid,
  CardHeader,
} from "@mui/material";
import { BookingApi } from "../../API/Apis/BookingApi";
import { t } from "i18next";
import TablePagination from "@mui/material/TablePagination";
import DefaultPage from "../../components/Layouts/DefaultPage";
import AlertMessage from "../AlertMessage";
import { createTheme, Theme } from "@mui/material/styles";
import { formatThemeForReservedArea } from "../../config/MuiColorThemes";
import AppStandardButton from "../../components/UI/AppButtons";
import DownloadIcon from "@mui/icons-material/Download";

export default function InvoiceCard(props) {
  const { searchInvoice } = props;
  const [invoiceList, setInvoiceList] = useState<any>([]);
  const [allInvoiceList, setAllInvoiceList] = useState<any>([]);
  const [loader, setLoader] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [totalInvoices, setTotalInvoices] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [dynamicTheme, setDynamicTheme] = useState<Theme | null>(null);
  const isSmallScreen = window.innerWidth <= 768;
  useEffect(() => {
    async function fetchTheme() {
      const dynamicPalette = await formatThemeForReservedArea();
      const theme = createTheme(dynamicPalette);
      setDynamicTheme(theme);
    }
    fetchTheme();
  }, []);
  const primaryColor = dynamicTheme?.palette["primary"]?.main;
  const requestOnClose = () => {
    setOpenModal(false);
    setModalMessage("");
  };
  const handlePageChange = (event: unknown, page: number) => {
    setPage(page);
  };

  const handleRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const downloadInvoice = (invoiceId) => {
    if (invoiceId == "No Invoice Found") {
      setModalMessage("No Invoice Found");
      setOpenModal(true);
    } else {
      BookingApi.downloadInvoice(invoiceId).then((e) => {
        if (e.data.status == "error") {
          setModalMessage(e.data.errorMessage);
          setOpenModal(true);
        } else {
          const url = e.data;
          window.open(url, "_blank");
        }
      });
    }
  };
  useEffect(() => {
    if (searchInvoice != null && searchInvoice != "") {
      const searchTerm = searchInvoice.trim().toLowerCase();
      const filteredInvoices = allInvoiceList.filter((invoice) => {
        const prefix = invoice?.prefix.toLowerCase();
        const number = invoice?.invoiceNumber?.toString();
        console.log("number", number);
        return (
          prefix.includes(searchTerm) ||
          number.includes(searchTerm) ||
          searchTerm.includes(prefix + number)
        );
      });
      setTotalInvoices(filteredInvoices.length);
      setInvoiceList(filteredInvoices);
    } else {
      setTotalInvoices(allInvoiceList.length);
      setInvoiceList(allInvoiceList);
    }
  }, [searchInvoice]);

  useEffect(() => {
    setLoader(true);
    const id: any = localStorage.getItem("userID");
    const offset = page * rowsPerPage;
    BookingApi.getOnlineUserInvoices(id, offset, rowsPerPage).then((e) => {
      setTotalInvoices(e.data.total);
      setInvoiceList(e.data.invoiceList);
      setAllInvoiceList(e.data.invoiceList);
      setLoader(false);
    });
  }, [page, rowsPerPage]);
  return (
    <>
      <AlertMessage
        openModal={openModal}
        requestOnClose={requestOnClose}
        modalMessage={modalMessage}
      />
      {!isSmallScreen && (
        <>
          {loader ? (
            <Typography className="!text-center !text-3xl !flex !justify-center">
              Loading...
            </Typography>
          ) : (
            <div>
              {invoiceList.length === 0 ? (
                <DefaultPage
                  message={t("You haven't created any invoices yet.")}
                ></DefaultPage>
              ) : (
                <>
                  <TableContainer className="!shadow-grey-400 !rounded-2xl !border-solid !border-3 p-4">
                    <Table
                      className="!shadow-2xl rounded-2xl !border-solid !border-2 !border-grey-400"
                      aria-label="simple table"
                      stickyHeader
                    >
                      <TableHead className="!bg-[primary] rounded-2xl">
                        <TableRow className="!bg-[#dc1c24] rounded-2xl">
                          <TableCell
                            className="!text-[15px] rounded-tl-2xl"
                            style={{
                              backgroundColor:
                                dynamicTheme?.palette?.["primary"]?.main,
                              color:
                                dynamicTheme?.palette?.["primary"]
                                  ?.contrastText,
                            }}
                          >
                            {t("Invoice Number")}
                          </TableCell>
                          <TableCell
                            className="!text-[15px]"
                            style={{
                              backgroundColor:
                                dynamicTheme?.palette?.["primary"]?.main,
                              color:
                                dynamicTheme?.palette?.["primary"]
                                  ?.contrastText,
                            }}
                          >
                            {t("Start Date")}
                          </TableCell>
                          <TableCell
                            className="!text-[15px]"
                            style={{
                              backgroundColor:
                                dynamicTheme?.palette?.["primary"]?.main,
                              color:
                                dynamicTheme?.palette?.["primary"]
                                  ?.contrastText,
                            }}
                          >
                            {t("End Date")}
                          </TableCell>
                          <TableCell
                            className="!text-[15px]"
                            style={{
                              backgroundColor:
                                dynamicTheme?.palette?.["primary"]?.main,
                              color:
                                dynamicTheme?.palette?.["primary"]
                                  ?.contrastText,
                            }}
                          >
                            {t("Invoice Amount")}
                          </TableCell>
                          <TableCell
                            className="!text-[15px]"
                            style={{
                              backgroundColor:
                                dynamicTheme?.palette?.["primary"]?.main,
                              color:
                                dynamicTheme?.palette?.["primary"]
                                  ?.contrastText,
                            }}
                          >
                            {t("Status")}
                          </TableCell>
                          <TableCell
                            className="text-[15px] rounded-tr-2xl"
                            style={{
                              backgroundColor:
                                dynamicTheme?.palette?.["primary"]?.main,
                              color:
                                dynamicTheme?.palette?.["primary"]
                                  ?.contrastText,
                            }}
                          >
                            {t("Download")}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {invoiceList.map((e: any, i) => (
                          <TableRow key={i}>
                            <TableCell
                              className="!text-[12px] text-[#333] rounded-bl-2xl"
                              component="th"
                              scope="e"
                            >
                              <ul>
                                <li>
                                  {e.prefix + "-" + e.invoiceNumber || ""}
                                </li>
                                <li className="text-[#838181] text-[10px]">
                                  {e.rentalAgreement != null &&
                                  e.rentalAgreement != ""
                                    ? "Rental" + " " + e.rentalAgreement
                                    : "Reservation" + " " + e.reservation}
                                </li>
                              </ul>
                            </TableCell>
                            <TableCell className="!text-[12px] text-[#333]">
                              {e.startDate || ""}
                            </TableCell>
                            <TableCell className="!text-[12px] text-[#333]">
                              {e.invoiceEndDate || ""}
                            </TableCell>
                            <TableCell className="!text-[12px] text-[#333]">
                              {"€" + " " + e.totInvoice || ""}
                            </TableCell>
                            <TableCell>
                              <div
                                className="!text-[11px] text-[#333]"
                                style={{
                                  backgroundColor: e.isPaid
                                    ? "lightgreen"
                                    : "#FF634748",
                                  color: e.isPaid ? "#008741" : "primary",
                                  textAlign: "center",
                                  borderRadius: "8px",
                                  fontSize: "20px",
                                  fontWeight: "bold",
                                  padding: "10px",
                                }}
                              >
                                {e.isPaid ? "Paid" : "Unpaid"}
                              </div>
                            </TableCell>
                            <TableCell>
                              <AppStandardButton
                                onClick={() => downloadInvoice(e.id)}
                                className={`flex text-[12px] gap-2 h-30 rounded shadow`}
                                style={{
                                  borderRadius: "5",
                                  color: primaryColor,
                                }}
                              >
                                <span className="normal-case text-white flex items-center gap-1 font-light">
                                  <DownloadIcon className="w-3 h-3 text-white" />
                                </span>
                              </AppStandardButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                    }}
                    rowsPerPageOptions={[8]}
                    component="div"
                    count={totalInvoices}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleRowsPerPage}
                  />
                </>
              )}
            </div>
          )}
        </>
      )}

      {isSmallScreen && (
        <>
          {loader ? (
            <Typography className="!text-center !text-3xl !flex !justify-center">
              Loading...
            </Typography>
          ) : (
            <>
              <div>
                {invoiceList.length === 0 ? (
                  <DefaultPage
                    message={"You haven't created any invoices yet."}
                  ></DefaultPage>
                ) : (
                  <>
                    <Grid container spacing={2}>
                      {invoiceList.map((e: any, i) => (
                        <Grid item xs={12} sm={6} md={4} key={i}>
                          <Card
                            className="!shadow-2xl rounded-2xl !border-solid !border-2 !border-grey-400 whitespace-nowrap"
                            style={{ borderRadius: "10px 10px 10px 10px" }}
                          >
                            <CardHeader
                              title={t("Invoice Id:") + e.id}
                              style={{
                                color:
                                  dynamicTheme?.palette?.["primary"]
                                    ?.contrastText,
                                backgroundColor:
                                  dynamicTheme?.palette?.["primary"]?.main,
                                height: "30px",
                                padding: "8px 16px",
                                lineHeight: "1.5",
                                borderRadius: "10px 10px 0px 0px",
                              }}
                              titleTypographyProps={{
                                style: {
                                  color: "white",
                                },
                              }}
                            />
                            <CardContent>
                              <Typography
                                className="!text-[15px]"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span> {t("Invoice Number")}</span>
                                <span>
                                  {" "}
                                  {e.prefix}-{e.invoiceNumber}
                                </span>
                              </Typography>
                              <hr />
                              <Typography
                                className="!text-[15px]"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span> {t("Start Date")}</span>
                                <span>{e.startDate}</span>
                              </Typography>
                              <hr />
                              <Typography
                                className="!text-[15px]"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span> {t("End Date")}</span>
                                <span>{e.invoiceEndDate}</span>
                              </Typography>
                              <hr />
                              <Typography
                                className="!text-[15px]"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span>{t("Invoice Amount")}</span>
                                <span>€ {e.totInvoice}</span>
                              </Typography>
                              <hr />
                              <Typography
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span
                                  className="!text-[15px]"
                                  style={{
                                    backgroundColor: e.isPaid
                                      ? "lightgreen"
                                      : "#FF634748",
                                    color: e.isPaid ? "#008741" : "primary",
                                    textAlign: "center",
                                    borderRadius: "8px",
                                    fontSize: "20px",
                                    fontWeight: "bold",
                                    padding: "10px",
                                    margin: "10px",
                                  }}
                                >
                                  {e.isPaid ? "Paid" : "Unpaid"}
                                </span>
                                <span>
                                  <AppStandardButton
                                    onClick={() => downloadInvoice(e.id)}
                                    className={`flex text-[12px] gap-2 h-30 rounded shadow m-2`}
                                    style={{
                                      borderRadius: "5",
                                      color: primaryColor,
                                    }}
                                  >
                                    <span className="normal-case text-white flex items-center gap-1 font-light p-1">
                                      <DownloadIcon className="w-3 h-3 text-white " />
                                    </span>
                                  </AppStandardButton>
                                </span>
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </>
                )}
              </div>
              <TablePagination
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
                rowsPerPageOptions={[8]}
                component="div"
                count={totalInvoices}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPage}
              />
            </>
          )}
        </>
      )}
    </>
  );
}
